export enum GatewayTypeOPEEnum {
  GetGatewayTypes = 'getGatewayTypes',
  PutGatewayType = 'putGatewayType',
  DelGatewayType = 'delGatewayType'
}
